// extracted by mini-css-extract-plugin
export default {"spinner":"FullscreenLoader_spinner__kQ0m9"};